module.exports = __webpack_public_path__ + "img/news2.550d6498.jpg";